// extracted by mini-css-extract-plugin
export default {"content":"car-module__content","text":"car-module__text","models":"car-module__models","head":"car-module__head","modalStyle":"car-module__modalStyle"};